export enum ContactDetails {
  SUPPORT_EMAIL = 'support@coleap.io',
}
